import NGOSettingsLayout from 'features/ngo/settings'
import React from 'react'

const NGOSettings = () => {
  return (
    <NGOSettingsLayout />
  )
}

export default NGOSettings